// extracted by mini-css-extract-plugin
module.exports =  {"tag":"_HBb65i","tag-remove":"K7wqL07","tagRemove":"K7wqL07"};